import React, { useState } from 'react'
import { Link, useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container, Card, CardBody } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import SupportModal from '../components/SupportModal'

import MainLayout from '../layouts/MainLayout';
function Tutorials() {
    const [isSupportOpen, setIsSupportOpen] = useState(false);
    const openSupport = () => {
        setIsSupportOpen(true)
        // profileDispatch({ type: INCREMENT_CONTRACTS, stampNom: profile.nom151.remaining > 0 })
    }
    const closeSupport = () => {
        setIsSupportOpen(false)
    }
    const { t } = useTranslation('common')

  return (
    <MainLayout>  
      <Container>
      <h3 className="font-weight-bold mb-0">{t('tutorials.title')}</h3>
                <p className="text-muted mb-5">{t('tutorials.subtitle')}</p>

        <div className="row w-100">
            <div className="col-lg-6">
                <h5 className="font-weight-bold mb-0">{t('tutorials.tutorial_four_title')}</h5>
                <p className="text-muted">{t('tutorials.tutorial_four_description')} </p>
                <div className="video-container mb-5 mt-4">
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/TTBDxrG0QTA" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
            </div>
            <div className="col-lg-6">
                <h5 className="font-weight-bold mb-0">{t('tutorials.tutorial_one_title')}</h5>
                <p className="text-muted">{t('tutorials.tutorial_one_description')}</p>
            <div className="video-container mb-5">
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/zsvx1gUwMsw" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>

            </div>
            <div className="col-lg-6">
            <h5 className="font-weight-bold mb-0">{t('tutorials.tutorial_two_title')}</h5>
                <p className="text-muted">{t('tutorials.tutorial_two_description')}</p>
                <div className="video-container mb-5">
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/ZK2wBWcb43U" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
            </div>
            <div className="col-lg-6">
            <h5 className="font-weight-bold mb-0">{t('tutorials.tutorial_three_title')}</h5>
                <p className="text-muted">{t('tutorials.tutorial_three_description')}</p>
                <div className="video-container mb-5">
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/eZBwWlQkaTM" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
            </div>
        </div>
      </Container>
    </MainLayout>
  )
}

export default Tutorials

